import type { useOffersByIdsQuery } from '@hooks/useOffersByIdsQuery'

import type { SelectedProduct } from '../AppsTwitch.types'

type OffersByIds = ReturnType<typeof useOffersByIdsQuery>['offersByIdsQuery']['data']

export const mapOffersDataToSelectedProducts = (data: OffersByIds): SelectedProduct[] => {
  if (!data) {
    return []
  }

  return Object.values(data).map((offer) => ({
    id: offer.id,
    name: offer.name,
    image: offer.primaryImage?.thumbnail.url,
    status: offer.state.status,
  }))
}
